/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { RentalDataBedTypes, RentalDataPropertyTypes } from '@zcode/bizos'
import { RENT_RESEARCH_DETAIL_INITIAL_STATE, RENT_RESEARCH_DETAIL_SLICE_NAME } from '../constants'

export const rentResearchDetailMetaSlice = createSlice({
  name: `${RENT_RESEARCH_DETAIL_SLICE_NAME}/meta`,
  initialState: RENT_RESEARCH_DETAIL_INITIAL_STATE.meta,
  reducers: {
    errorFetchingRentResearchDetailRentalData: (state, { payload }: PayloadAction<string>) => {
      if (state.fetchingKey === payload) {
        state.errorKey = payload
        state.fetchingKey = null
      }
    },
    doneFetchingRentResearchDetailRentalData: (state, { payload }: PayloadAction<string>) => {
      if (state.fetchingKey === payload) {
        state.errorKey = null
        state.fetchingKey = null
        state.currentKey = payload
      }
    },
    setRentResearchDetailActiveBedType: (
      state,
      { payload }: PayloadAction<RentalDataBedTypes | null>
    ) => {
      state.activeBedType = payload
    },
    setRentResearchDetailActivePropertyType: (
      state,
      { payload }: PayloadAction<RentalDataPropertyTypes | null>
    ) => {
      state.activePropertyType = payload
    },
    startFetchingRentResearchDetailRentalData: (state, { payload }: PayloadAction<string>) => {
      state.fetchingKey = payload
    },
  },
})
